import React, { ReactElement } from 'react';

// Styles
import './styles.scss';

interface Props {
    children: string | ReactElement | React.ReactNode;
}

const Bold = ({ children }: Props): React.ReactElement => (
    <span className="bold">{children}</span>
);

export default Bold;
